import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerWrapper = (props) => {
  const { input, label, minDate, maxDate, readOnly } = props;
  const [startDate, setStartDate] = useState(input.value);
  return (
    <div>
      <label>{label}</label>
      <DatePicker
        dateFormat="MM/dd/yyyy"
        showPopperArrow={false}
        showMonthDropdown
        dropdownMode="select"
        selected={startDate}
        minDate={minDate}
        maxDate={maxDate}
        todayButton="Today"
        onChange={(value) => {
          setStartDate(value);
          props.input.onChange(value);
        }}
        onBlur={props.input.onBlur}
        onFocus={props.input.onFocus}
        value={props.input.value}
        placeholderText="mm/dd/yyyy"
        readOnly={readOnly}
      />
    </div>
  );
};

export default DatePickerWrapper;
